import React, { useState } from "react";
import { useSelector } from 'react-redux';
import './index.scss';
import { ROUTE_PATH } from "@/utils/Global";
import BasicButton from "@/Common/ButtonsV2/BasicButton";
import i18n from "@/i18n";
import { Trans } from "react-i18next";

const PriceSection = ({ history }) => {
    const lang = useSelector(state => state.langStore.lang);

    const handleStartButtonClick = () => {
        history.push(ROUTE_PATH.DESIGN_SELECT);
    }

    return (
        <div className="price-section-wrapper">
            <div className="price-section-content">
                <img src="https://front.videomonster.com/images-7cuytg20/web/v2/landing2025/vm-icon.svg" alt="Logo" />
                <div className="price-section-main-message">
                    <span>{i18n.t("web.pc.landing.2025.price.des.1")}</span>
                    <span className="primary-color">{i18n.t("web.pc.landing.2025.price.des.2")}</span>
                    <span className="primary-color">
                        <Trans i18nKey="web.pc.landing.2025.price.des.3">
                            <strong />
                        </Trans>
                    </span>
                </div>
                {
                    lang === "ko" && (
                        <div className="price-section-sub-message">
                            <span>
                                {i18n.t("web.pc.landing.2025.price.sub.des")}
                            </span>
                        </div>
                    )
                }
                <BasicButton text={i18n.t("global.go.to.make")} onClick={handleStartButtonClick} color="primary" />
            </div>
        </div>
    )
}

export default PriceSection;